import React from 'react';
import { motion } from 'framer-motion';

interface NumberOneBadgeProps {
  lang?: 'en' | 'fr' | 'de' | 'it';
}

const NumberOneBadge: React.FC<NumberOneBadgeProps> = ({ lang = 'en' }) => {
  const translations = {
    en: {
      numberOne: '#1 App',
      tableTennis: 'Table Tennis',
      inSwitzerland: 'in Switzerland'
    },
    fr: {
      numberOne: 'App #1',
      tableTennis: 'Tennis de Table',
      inSwitzerland: 'en Suisse'
    },
    de: {
      numberOne: '#1 App',
      tableTennis: 'Tischtennis',
      inSwitzerland: 'in der Schweiz'
    },
    it: {
      numberOne: '#1 App',
      tableTennis: 'Ping Pong',
      inSwitzerland: 'in Svizzera'
    }
  };

  const t = translations[lang];

  return (
    <motion.div
      className="flex items-center justify-center"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.6, delay: 0.3 }}
    >
      {/* Left Podium */}
      <motion.img
        src="/left_podium.png"
        alt=""
        className="w-[30px] h-[60px] opacity-70"
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 0.7, x: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
      />

      <div className="w-3" />

      {/* Center Text */}
      <motion.div
        className="flex flex-col items-center"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.6 }}
      >
        <div className="text-lg font-bold text-gray-700 dark:text-gray-300 transition-colors duration-300">
          {t.numberOne}
        </div>
        <div className="text-base text-gray-700 dark:text-gray-300 transition-colors duration-300">
          {t.tableTennis}
        </div>
        <div className="text-sm text-gray-600 dark:text-gray-400 opacity-80 transition-colors duration-300">
          {t.inSwitzerland}
        </div>
      </motion.div>

      <div className="w-3" />

      {/* Right Podium */}
      <motion.img
        src="/right_podium.png"
        alt=""
        className="w-[30px] h-[60px] opacity-70"
        initial={{ opacity: 0, x: 10 }}
        animate={{ opacity: 0.7, x: 0 }}
        transition={{ duration: 0.5, delay: 0.5 }}
      />
    </motion.div>
  );
};

export default NumberOneBadge;
